import React from "react";

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.subtitle = props.subtitle;
    this.state = {
      active: false,
      navBarActiveClass: ""
    };
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: "is-active"
            })
          : this.setState({
              navBarActiveClass: ""
            });
      }
    );
  };

  render() {
    return (
      <nav className="navbar " role="navigation" aria-label="main-navigation">
        <div className="container">
          <div className="navbar-brand">
            {/* <Link to="/" className="navbar-item" title="Logo">
              <img src={logo} alt="Kaldi" style={{ width: '88px' }} />
            </Link> */}
            <div className="navbar-start has-text-bottom">
              <div
                id="navMenu"
                className={`navbar-menu ${this.state.navBarActiveClass}`}
              ></div>
            </div>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-end has-text-bottom">
              <a className="navbar-item" href="#prime-time">
                Prime Time
              </a>
              <a className="navbar-item" href="#b4publishing">
                B4 Publishing
              </a>
              <a className="navbar-item" href="#training-station">
                The Training Station
              </a>
              <a className="navbar-item" href="#equipe">
                Equipe
              </a>
              <a className="navbar-item" href="#contact">
                Contact
              </a>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
